import {HandleServerError} from '../../utils/serverErrorHandler';
import api from "../../utils/apiClient";
import axios from 'axios';
export const RESET = 'RESET';
export const SET_CITY = 'SET_CITY';
export const SET_USER = 'SET_USER';
export const SET_USER_TOKEN = 'SET_USER_TOKEN';
export const SET_USER_DETAILS = 'SET_USER_DETAILS';
export const SET_SNACKBAR_PROPS = 'SET_SNACKBAR_PROPS';
export const SEARCH_ISSUE = 'SEARCH_ISSUE';
export const GET_DESIGN = 'GET_DESIGN';


export const resetStore = user => ({
    type: RESET,
    data: { user }
});
  
export const cityChange = data => ({
    type:SET_CITY,
    data
});

export const setUser = user => ({
    type: SET_USER,
    data: { user }
});

export const setUserDetails = data =>({
    type: SET_USER_DETAILS,
    data,
});
export const setUserToken = token =>({
    type: SET_USER_TOKEN,
    token,
});

export const setSnackBarProps = data => ({
    type: SET_SNACKBAR_PROPS,
    data
});



export function searchIssues(payload) {
    let data;
	return {
		type: SEARCH_ISSUE,
        data,
		promise: axios.post(`https://guardian-professional.bricknbolt.com/inspectionService/api/v3/issue/search`, payload, {
            headers: {
                'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZGl0aXNAYnJpY2tuYm9sdC5jb20iLCJpZCI6IjVmZGM5MWJlMDkwM2ZiMjY2ODYzY2U4OCIsImV4cCI6MTY1NjkzNTM2MSwiaWF0IjoxNjU2NzYyNTYxfQ.RWTDKOuUnUVi3wkHzlhyAvPK9ndOYtrddZK_nPzAv6DQASzO99usJjjvNKuKnTqUZuvNdf6mwVWol4Cv9go4wA'
            },
            params: {
                loadDetails:true
            },
        }).then(res => {
            data = res.data;
        }),
		transformer: (x) => { console.log('trans',x); return x},
	};
}

export function createIssue(payload) {
    let data;
	return {
		type: GET_DESIGN,
        data,
		promise: axios.post(`https://guardian-professional.bricknbolt.com/inspectionService/api/v3/issue/create`, payload, {
            headers: {
                'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZGl0aXNAYnJpY2tuYm9sdC5jb20iLCJpZCI6IjVmZGM5MWJlMDkwM2ZiMjY2ODYzY2U4OCIsImV4cCI6MTY1NjkzNTM2MSwiaWF0IjoxNjU2NzYyNTYxfQ.RWTDKOuUnUVi3wkHzlhyAvPK9ndOYtrddZK_nPzAv6DQASzO99usJjjvNKuKnTqUZuvNdf6mwVWol4Cv9go4wA'
            }
        }).then(res => {
            data = res.data;
        }),
		transformer: (x) => { console.log('trans',x); return x},
	};
}

export function createIssueTimeline(payload) {
    let data;
	return {
		type: GET_DESIGN,
        data,
		promise: axios.post(`https://guardian-professional.bricknbolt.com/inspectionService/api/v3/issue/timeline/create`, payload, {
            headers: {
                'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZGl0aXNAYnJpY2tuYm9sdC5jb20iLCJpZCI6IjVmZGM5MWJlMDkwM2ZiMjY2ODYzY2U4OCIsImV4cCI6MTY1NjkzNTM2MSwiaWF0IjoxNjU2NzYyNTYxfQ.RWTDKOuUnUVi3wkHzlhyAvPK9ndOYtrddZK_nPzAv6DQASzO99usJjjvNKuKnTqUZuvNdf6mwVWol4Cv9go4wA'
            }
        }).then(res => {
            // console.log('res', res); data = res.data;
        }),
		transformer: (x) => { console.log('trans',x); return x},
	};
}

export function createdIssueTimeline(payload) {
    let data;
	return {
		type: GET_DESIGN,
        data,
		promise: axios.post(`https://guardian-professional.bricknbolt.com/inspectionService/api/v3/issue/timeline/create`, payload, {
            headers: {
                'Authorization': 'Bearer eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZGl0aXNAYnJpY2tuYm9sdC5jb20iLCJpZCI6IjVmZGM5MWJlMDkwM2ZiMjY2ODYzY2U4OCIsImV4cCI6MTY1NjkzNTM2MSwiaWF0IjoxNjU2NzYyNTYxfQ.RWTDKOuUnUVi3wkHzlhyAvPK9ndOYtrddZK_nPzAv6DQASzO99usJjjvNKuKnTqUZuvNdf6mwVWol4Cv9go4wA'
            }
        }).then(res => {
            data = res.data;
        }),
		transformer: (x) => { console.log('trans',x); return x},
	};
}
